import { useVisibilityStore } from '@/visibility/visibility.store';
import { goalbookUrls } from "@/util/links.js";

export default {
  beforeMount() {
    const visibilityStore = useVisibilityStore();
    if (!visibilityStore.iodVisibility) {
      if (!goalbookUrls.toolkitHome) {
        console.error('toolkitHome URL not configured');
        return;
      }
      window.location.replace(goalbookUrls.toolkitHome)
    }
  },
};
